import { defineMessages } from 'react-intl'

export const locale = defineMessages({
  getToKnowUs: {
    id: 'footer.get-to-know-us',
    defaultMessage: 'Get to know us',
  },
  about: {
    id: 'footer.about',
    defaultMessage: 'About',
  },
  jobs: {
    id: 'footer.jobs',
    defaultMessage: 'Jobs',
  },
  blog: {
    id: 'footer.blog',
    defaultMessage: 'Blog',
  },
  getHelp: {
    id: 'footer.get-help',
    defaultMessage: 'Get help',
  },
  contactUs: {
    id: 'footer.contact-us',
    defaultMessage: 'Contact us',
  },
  findEvents: {
    id: 'footer.find-events',
    defaultMessage: 'Find events',
  },
  topEvents: {
    id: 'footer.top-events',
    defaultMessage: 'Top events',
  },
  hostEvents: {
    id: 'footer.host-events',
    defaultMessage: 'Host events',
  },
  becomeHost: {
    id: 'footer.become-a-host',
    defaultMessage: 'Become a host',
  },
  tour: {
    id: 'footer.tour',
    defaultMessage: 'Tour',
  },
  embeddableWidgets: {
    id: 'footer.embeddable-widgets',
    defaultMessage: 'Embeddable widgets',
  },
  customers: {
    id: 'footer.customers',
    defaultMessage: 'Customers',
  },
  pricing: {
    id: 'footer.pricing',
    defaultMessage: 'Pricing',
  },
  getOnsiteApp: {
    id: 'footer.get-the-onsite-app',
    defaultMessage: 'Get the onsite app',
  },
  developers: {
    id: 'footer.developers',
    defaultMessage: 'Developers',
  },
  termsAndConditions: {
    id: 'footer.terms-and-conditions',
    defaultMessage: 'Terms and Conditions',
  },
  termsOfUse: {
    id: 'footer.terms-of-use',
    defaultMessage: 'Terms of Use',
  },
  privacyPolicy: {
    id: 'footer.privacy-policy',
    defaultMessage: 'Privacy policy',
  },
  cookiePolicy: {
    id: 'footer.cookie-policy',
    defaultMessage: 'Cookie policy',
  },
  manageCookies: {
    id: 'footer.manage-cookies',
    defaultMessage: 'Manage cookies',
  },
  doNotSellMyInformation: {
    id: 'footer.do-not-sell-my-information',
    defaultMessage: 'Do Not Sell Or Share My Personal Information',
  },
})
